import { SHOW_MODAL } from "core-web/state/models/Modal/constants";
import store from "core-web/state/store";

const showModal = (theme, data) => (dispatch) => {
    dispatch({
        type: SHOW_MODAL,
        theme,
        data,
    });
};

export default (theme, data) => store.dispatch(showModal(theme, data));
